import { render } from "./TinyPumperIncidentTriage.vue?vue&type=template&id=6d265586"
import script from "./TinyPumperIncidentTriage.vue?vue&type=script&lang=js"
export * from "./TinyPumperIncidentTriage.vue?vue&type=script&lang=js"

import "./TinyPumperIncidentTriage.vue?vue&type=style&index=0&id=6d265586&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__